var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPhotoLk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1050_14634)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    rx: 150,
    fill: "#F8F9F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 118.689,
    r: 62.2573,
    fill: "#C8D0CE",
    stroke: "#C8D0CE",
    strokeWidth: 3.64078
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6055 271.137C50.6055 232.843 77.4399 199.819 114.864 191.946L124.986 196.19C140.284 202.606 157.523 202.572 172.796 196.098L182.596 191.943C221.432 199.812 249.392 233.96 249.392 273.636V298.18H50.6055V271.137Z",
    fill: "#C8D0CE",
    stroke: "#C8D0CE",
    strokeWidth: 3.64078
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_14634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    rx: 149.272,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhotoLk);
export default __webpack_public_path__ + "static/media/noPhotoLk.48dfdaeaf7dfedd29b0eea2c0eccd1f3.svg";
export { ForwardRef as ReactComponent };